export enum FranchiseeFields {
    created_at = 'Editado em',
    id = 'Id do franqueado',
    company_percentage = 'Franqueados vinculados',
    deleted_at = 'Franqueados vinculados'
}